import type React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import st from './ConfirmImpossibilityOfDepartmentDeletion.module.sass';
import { useConfirmImpossibilityOfDepartmentDeletionTranslation } from './i18n';
import { buildTestid } from '../../../shared/lib/utils';

interface ConfirmImpossibilityOfDepartmentDeletionProps extends WithDataTestid {
  onConfirm: VoidFunction;
}

const displayName = 'ConfirmImpossibilityOfDepartmentDeletion';
const testid = buildTestid(displayName);

function ConfirmImpossibilityOfDepartmentDeletion({
  onConfirm,
  'data-testid': dataTestId = undefined,
}: ConfirmImpossibilityOfDepartmentDeletionProps): React.JSX.Element {
  const { t } = useConfirmImpossibilityOfDepartmentDeletionTranslation();

  return (
    <div
      className={st.ConfirmImpossibilityOfDepartmentDeletion}
      {...testid(dataTestId)}
    >
      <div className={st.Header}>
        <InfoCircleIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>{t('title')}</span>
          <span className={st.Details}>{t('description')}</span>
        </div>
      </div>

      <div className={st.Actions}>
        <Button
          className={st.Action}
          kind="primary"
          onClick={onConfirm}
          variant="filled"
        >
          {t('submit')}
        </Button>
      </div>
    </div>
  );
}

ConfirmImpossibilityOfDepartmentDeletion.displayName = displayName;

export { ConfirmImpossibilityOfDepartmentDeletion };
